import {config} from './init.ts';
import {compileRoutes} from '@alchemy/navigation';
import PublicationPage from './pages/PublicationPage';
import AppAuthorizationCodePage from './pages/AppAuthorizationCodePage';
import {NotFoundPage} from '@alchemy/phrasea-ui';
import EmbeddedAssetPage from './pages/EmbeddedAssetPage';
import IndexPage from './pages/IndexPage.tsx';
import PublicationEditPage from './pages/PublicationEditPage.tsx';
import ProfileEditPage from './pages/ProfileEditPage.tsx';
import ProfileListPage from './pages/ProfileListPage.tsx';
import ProfileCreatePage from './pages/ProfileCreatePage.tsx';
import {AuthConstant} from '@alchemy/auth';

const routes = {
    index: {
        public: true,
        path: '/',
        component: NotFoundPage,
    },
    publicationView: {
        public: true,
        path: ':id',
        component: PublicationPage,
        routes: {
            asset: {
                path: ':assetId',
                component: PublicationPage,
            },
        },
    },
    publication: {
        path: 'publications/:id',
        public: false,
        routes: {
            edit: {
                path: 'edit',
                component: PublicationEditPage,
            },
        },
    },
    profile: {
        path: 'profiles',
        public: false,
        routes: {
            index: {
                path: '',
                component: ProfileListPage,
            },
            create: {
                path: 'create',
                component: ProfileCreatePage,
            },
            edit: {
                path: ':id/edit',
                component: ProfileEditPage,
            },
        },
    },
    embedAsset: {
        public: true,
        path: 'embed/:assetId',
        component: EmbeddedAssetPage,
    },
    auth: {
        path: AuthConstant.DefaultCheckCodePath,
        public: true,
        component: AppAuthorizationCodePage,
    },
};

if (!config.disableIndexPage) {
    routes.index.component = IndexPage;
}

const compiledRoutes = compileRoutes(routes) as typeof routes;
export {compiledRoutes as routes};
